import * as tslib_1 from "tslib";
import controlStrings from 'owa-strings/owa-common-strings';
import datapoints from './datapoints';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import getItem from 'owa-mail-store/lib/services/getItem';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import reportMessageToSafetyLibraryService from '../services/reportMessageToSafetyLibraryService';
import store from 'owa-mail-store/lib/store/Store';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { format } from 'owa-strings';
import { handleServiceError } from 'owa-service-error';
import { listViewStore } from 'owa-mail-list-store';
var UnsubscribeEmailActionName = 'unsubscribeEmail';
// The regular expression of message header of a trusted sender
var TRUSTED_MESSAGE_HEAD_REGX = new RegExp('List-Unsubscribe:[ ]+<mailto:');
/**
 * Perform the unsubscribe action without the confirmation dialog
 * @param message the message
 * @param originalTableView the table view that message belongs to
 * @param isTrustedUnsubscribe whether to set actionData for trusted unsubscribe
 * @param actionSource the user source that initated the action
 */
var unsubscribeWithoutConfirmDialog = action('unsubscribeWithoutConfirmDialog', datapoints.unsubscribeDatapoint)(function unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = handleServiceError(UnsubscribeEmailActionName, strings.errorUnsubscribe, function () {
        return reportMessageToSafetyLibraryService([message.ItemId.Id], 5 /* Unsubscribe */, isTrustedUnsubscribe ? [1] : undefined);
    }, function (isSuccessful) {
        return { isSuccessful: isSuccessful };
    });
    var itemContext = {
        itemId: message.ItemId.Id,
        conversationId: message.ConversationId.Id,
        isRead: message.IsRead,
    };
    deleteItemsStoreUpdate([itemContext], message.ParentFolderId.Id);
    return actionResponse;
});
/**
 * Show the unsubscribe confirmation dialog
 * @param message the message
 * @param originalTableView the table view
 * @param isTrustedUnsubscribe whether to perform the trusted unsubscribe
 * @param actionSource the user source that initated the action
 * @return a Promise when the action completes
 */
var showUnsubscribeDialog = action('showUnsubscribeDialog')(function showUnsubscribeDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    var _this = this;
    return confirm(strings.unsubscribeDialogTitleText, format(strings.unsubscribeDialogSubTitleText, message.From.Mailbox.Name), false /* resolevImmediately */, {
        okText: strings.unsubscribe,
        cancelText: controlStrings.cancelButton,
    }).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === DialogResponse.ok) {
                return [2 /*return*/, unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource)];
            }
            return [2 /*return*/];
        });
    }); });
});
/**
 * Perform the unsubscribe action with the confirmation dialog
 * @param itemId the item id
 * @param tableViewId the table view id
 * @param actionSource the user source that initated the action
 * @param state the state which contains the tableView and reportToExternalSender in user configuration
 */
export default select({
    message: function (itemId, tableViewId) { return store.items.get(itemId); },
    originalTableView: function (itemId, tableViewId) {
        return listViewStore.tableViews.get(tableViewId);
    },
    reportToExternalSender: function () { return getUserConfiguration().SafetyUserOptions.ReportToExternalSender; },
})(action(UnsubscribeEmailActionName)(function unsubscribeEmail(itemId, tableViewId, actionSource, state) {
    var message = state.message, originalTableView = state.originalTableView, reportToExternalSender = state.reportToExternalSender;
    var isMessageLevelSafeOrTrusted = message.MessageSafety &&
        (message.MessageSafety.MessageSafetyLevel == 2 /* Safe */ ||
            message.MessageSafety.MessageSafetyLevel == 1 /* Trusted */);
    if (!reportToExternalSender || !isMessageLevelSafeOrTrusted) {
        // Show confirmation dialog for untrusted sender unsubscribe if reportToExternalSender is not enabled,
        // or the MessageSafetyLevel isn't Safe or Trusted
        return showUnsubscribeDialog(message, originalTableView, false /* isTrustedUnsubscribe */, actionSource);
    }
    var itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
    });
    // We need to get the headers for this message to test
    // for the List-Unsubscribe before performing a trusted unsubscribe
    return getItem([message.ItemId.Id], itemShape, 'MessageDetails').then(function (response) {
        if (response[0].ResponseClass == 'Success') {
            var responseItem = response[0];
            var messageHeader = responseItem.Items[0].ExtendedProperty &&
                responseItem.Items[0].ExtendedProperty[0].Value;
            return showUnsubscribeDialog(message, originalTableView, TRUSTED_MESSAGE_HEAD_REGX.test(messageHeader) /* isTrustedUnsubscribe */, actionSource);
        }
        else {
            throw new Error(response[0].MessageText);
        }
    });
}));
//# sourceMappingURL=unsubscribeEmail.js.map